import isEmpty from 'lodash/isEmpty'
import type {
  Action,
  AnyAction,
  ThunkAction,
  ThunkDispatch,
} from '@reduxjs/toolkit'
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { middleware as scsMiddleware } from '@racepointenergy/swc'
import { configureClient } from '@racepointenergy/swc'
import { clientMiddleware } from '@racepointenergy/swc/client/middleware'

import {
  scsAuthListenerOptions,
  scsDeauthListenerOptions,
} from '@racepointenergy/swc/scs/client/middleware'
import { resetStore } from 'app/store/actions'
import { ENV, SCS_AGENT, SCS_CHANNEL } from '../consts'

import { reducers } from './reducers'
import { StateKeysType } from './types'
import { WHITE_LISTED_REDUCERS } from './consts'

const swcConfig = require(`@racepointenergy/swc/client/config/config.${ENV}.js`)

const combinedReducer = combineReducers(reducers)

const rootReducer = (state: RootState | undefined, action: Action) => {
  if (action.type === resetStore.toString()) {
    const newState: Partial<Record<StateKeysType, unknown>> = {}
    if (!isEmpty(state) && !isEmpty(WHITE_LISTED_REDUCERS)) {
      WHITE_LISTED_REDUCERS.forEach((key) => (newState[key] = state?.[key]))
    }
    state = newState as RootState
  }

  return combinedReducer(state, action)
}

clientMiddleware.startListening(scsAuthListenerOptions)
clientMiddleware.startListening(scsDeauthListenerOptions)

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(clientMiddleware.middleware)
      .concat([scsMiddleware]),
  devTools: !['beta', 'production'].includes(ENV || ''),
})

store.dispatch(
  ///@ts-ignore
  configureClient({
    ...swcConfig.config,
    scs$agent: SCS_AGENT,
    scs$channel: SCS_CHANNEL,
  })
)

export type AppDispatch = ThunkDispatch<RootState, {}, AnyAction>
export type AppGetState = typeof combinedReducer
export type RootState = ReturnType<typeof combinedReducer>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
